module.exports = __webpack_public_path__ + "img/shj_feature.2516fa4c.png";